import { useTranslation } from 'react-i18next';
import { type DebriefStage } from '@momentum/types';
import { useDebriefFactsState } from '../../shared/context/DebriefFactsStateContext';
import { STAGE_META } from '../utils/stageMeta';
import { AddFactSection } from './AddFactSection';
import { EmptyStagePlaceholder } from './EmptyStagePlaceholder';
import { FactRow } from './FactRow';

interface FactStageSectionProps {
  stage: DebriefStage;
  isLast: boolean;
}

export function FactStageSection({ stage, isLast }: FactStageSectionProps) {
  const { t } = useTranslation('debriefV2');
  const { factsByStage } = useDebriefFactsState();
  const meta = STAGE_META[stage];
  const Icon = meta.icon;
  const facts = factsByStage[stage] ?? [];

  return (
    <div className="relative pt-8 pb-4">
      {!isLast && (
        <div
          className="absolute start-[19px] top-[80px] -bottom-4 w-px bg-slate-200"
          aria-hidden
        />
      )}

      <div className="flex items-center gap-4 mb-4 relative z-10">
        <div className="w-10 h-10 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center shadow-sm shrink-0">
          <Icon className="h-4 w-4 text-slate-400" aria-hidden />
        </div>
        <h3 className="text-lg font-semibold text-slate-900">
          {t(meta.labelKey)}
        </h3>
      </div>

      <div className="ms-[56px]">
        {facts.length === 0 ? (
          <EmptyStagePlaceholder stage={stage} />
        ) : (
          <div className="space-y-3">
            {facts.map((fact) => (
              <FactRow key={fact.id} fact={fact} />
            ))}
            <AddFactSection stage={stage} variant="inline" />
          </div>
        )}
      </div>
    </div>
  );
}
